import React from "react";
import style from "./Loader.module.css";

const Loader = ({className}) => {
  const combinedClassName = `${style.loaderContainer} ${className}`;
  return (
    <div className={combinedClassName}>
      <div className={style.spinner} />
    </div>
  );
};

export default Loader;
